import { render, staticRenderFns } from "./CashingUp.vue?vue&type=template&id=872c730c&"
import script from "./CashingUp.vue?vue&type=script&lang=js&"
export * from "./CashingUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports